export default __webpack_public_path__ + "static/media/box.eab0109c.svg";